import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as activity } from 'store/activity'
import { module as ui } from 'store/ui'
import {
    AlignContentHorizontal, CardIcon
} from "static/styled/custom.styled";

import Select from 'react-select'
import './activities_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
        value: 'CMS'
    },
    {
        label: 'CBSE',
        value: 'CBSE'
    },
    {
        label: 'Hello',
        value: 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const ActivitiesSyncModal = ({ activity, ui }) => {

    const [platforms, setPlatforms] = useState([])
    const [selectedActivities, setSelectedActivities] = useState(activity.sync_activities_list.map((str) => str.id))

    const handleCardClicked = (activity) => {
        if (selectedActivities.includes(activity.id)) {
            setSelectedActivities(prev => prev.filter((data) => data !== activity.id))
        } else {
            setSelectedActivities(prev => [...prev, activity.id])
        }
    }

    const handleSyncNow = () => {
        let payload = {
            platforms: platforms.map((plt) => plt.value),
            activity_ids: selectedActivities
        }
        activity.syncActivitiesToOtherPlatforms(payload)
        ui.hideModal()
    }

    const isChecked = (id) => selectedActivities.some((item) => item === id);

    return (
        <div className='stories_sync_modal'>
            <p className='stories_sync_modal_header'>Sync activities to other platforms</p>
            <div className="table-container">
                <table className="info-table">
                    <thead>
                        <tr className='stories_sync_table_header_row'>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Grade</th>
                            <th>Description</th>
                            <th>Tags</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activity.sync_activities_list && activity.sync_activities_list.length > 0 ?
                            activity.sync_activities_list.map((act, index) => {
                                return (
                                    <tr key={activity.id}>
                                        <td>
                                            <input type="checkbox" checked={isChecked(act.id)}
                                                onChange={() => handleCardClicked(act)} />
                                        </td>
                                        <td>{act.name}</td>
                                        <td>{activity.grades && activity.grades.length > 0 && activity.grades.find((grd) => grd.id === act.grade).name}</td>
                                        <td>{act.description}</td>
                                        <td>{act.tag && act.tag.length > 0 ? act.tag.join(", ") : "No tags added."}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr> No activities added to sync.</tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container stories_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    activity, ui
})(ActivitiesSyncModal)